import React, { useEffect } from 'react';
import { Layer, Stage, Image, Line, Rect, Circle } from 'react-konva';
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import { useIntl } from 'react-intl';
import { useQueryClient } from 'react-query';
import { QueryKey, useCalibrationDotsPosition, useRedLinePosition, useSelectedImage, steps } from '../helper';
import { KonvaEventObject } from 'konva/lib/Node';
import { CONTAINER_HEIGHT, CONTAINER_WIDTH } from '../models';
import { useBem } from '../../Bem';

export const Step6 = () => { // NOSONAR
  const queryClient = useQueryClient();
  const bem = useBem('step6');
  const intl = useIntl();
  const { redLinePosition } = useRedLinePosition();
  const { calibrationDotsPosition } = useCalibrationDotsPosition();

  const image = useSelectedImage();

  useEffect(() => {
    if (calibrationDotsPosition && redLinePosition) {
      const bootomPointY =
        redLinePosition && redLinePosition - (257 + 10 + 7 + 4) >= 1 ? redLinePosition - (257 + 10 + 7 + 4) : 1;
      calibrationDotsPosition[0].yPosition = redLinePosition;
      calibrationDotsPosition[1].yPosition = bootomPointY;
      calibrationDotsPosition[2].yPosition = redLinePosition;
      queryClient.setQueryData(QueryKey.calibrationDotsPosition, calibrationDotsPosition.slice());
    }
  }, [redLinePosition]);

  const updatePosition = (index: number, e: KonvaEventObject<MouseEvent>) => {
    const node = { ...calibrationDotsPosition[index] };
    node.xPosition = e.target.x();
    node.yPosition = e.target.y();
    if (index === 2) {
      calibrationDotsPosition[0] = { xPosition: calibrationDotsPosition[0].xPosition, yPosition: node.yPosition };
    }
    if (index === 0) {
      calibrationDotsPosition[2] = { xPosition: calibrationDotsPosition[2].xPosition, yPosition: node.yPosition };
    }

    calibrationDotsPosition[index] = node;
    queryClient.setQueryData(QueryKey.calibrationDotsPosition, calibrationDotsPosition.slice());
  };

  if (!calibrationDotsPosition) {
    return <></>;
  }
  return (
    <div>
      <p className={bem.elem('title').cls()}>
        <span>(6/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.titleStep_6)}</span>
      </p>
      <div className={bem.elem('canvas_margin').cls()}>
        <Stage className={bem.elem('canvas').cls()} width={CONTAINER_WIDTH} height={CONTAINER_HEIGHT}>
          <Layer>
            <Image image={image} x={0} y={0} />

            <Rect
              x={calibrationDotsPosition[0].xPosition - 10}
              y={calibrationDotsPosition[1].yPosition - 10}
              height={calibrationDotsPosition[0].yPosition - calibrationDotsPosition[1].yPosition + 20}
              width={calibrationDotsPosition[2].xPosition - calibrationDotsPosition[0].xPosition + 20}
              strokeWidth={4}
              stroke="#e74a4a"
            />

            <Line
              points={[
                calibrationDotsPosition[0].xPosition,
                calibrationDotsPosition[0].yPosition,
                calibrationDotsPosition[1].xPosition,
                calibrationDotsPosition[1].yPosition,
              ]}
              stroke="white"
              dash={[15, 10]}
              strokeWidth={4}
              lineJoin={'round'}
              lineCap={'round'}
            />
            <Line
              points={[
                calibrationDotsPosition[1].xPosition,
                calibrationDotsPosition[1].yPosition,
                calibrationDotsPosition[2].xPosition,
                calibrationDotsPosition[2].yPosition,
              ]}
              stroke="white"
              dash={[15, 10]}
              strokeWidth={4}
              lineJoin={'round'}
              lineCap={'round'}
            />

            {calibrationDotsPosition.map((node, index) => {
              return (
                <Circle
                  key={index}
                  radius={7}
                  fill="#e74a4a"
                  stroke="white"
                  onMouseEnter={(e: any) => {
                    const container = e.target.getStage().container();
                    container.style.cursor = 'move';
                  }}
                  onMouseLeave={(e: any) => {
                    const container = e.target.getStage().container();
                    container.style.cursor = 'default';
                  }}
                  x={node.xPosition}
                  y={node.yPosition}
                  draggable
                  onDragMove={(e) => updatePosition(index, e)}
                  dragBoundFunc={(pos) => {
                    pos.x = pos.x;
                    pos.y = pos.y;
                    if (pos.y >= redLinePosition) {
                      pos.y = redLinePosition - 1;
                    }
                    if (pos.y <= 0) {
                      pos.y = 1;
                    }
                    if (pos.x >= CONTAINER_WIDTH) {
                      pos.x = CONTAINER_WIDTH - 1;
                    }
                    if (pos.x <= 0) {
                      pos.x = 1;
                    }
                    if (index === 2) {
                      //restriction for right dot
                      if (pos.x < calibrationDotsPosition[1].xPosition + 7) {
                        pos.x = calibrationDotsPosition[1].xPosition + 7;
                      }
                      if (pos.y < calibrationDotsPosition[1].yPosition + 14) {
                        pos.y = calibrationDotsPosition[1].yPosition + 14;
                      }
                    }
                    if (index === 0) {
                      //restriction for left dot
                      if (pos.x > calibrationDotsPosition[1].xPosition - 7) {
                        pos.x = calibrationDotsPosition[1].xPosition - 7;
                      }

                      if (pos.y < calibrationDotsPosition[1].yPosition + 14) {
                        pos.y = calibrationDotsPosition[1].yPosition + 14;
                      }
                    }
                    if (index === 1) {
                      //restriction for top dot
                      if (pos.y > calibrationDotsPosition[0].yPosition - 14) {
                        pos.y = calibrationDotsPosition[0].yPosition - 14;
                      }
                      if (pos.x > calibrationDotsPosition[2].xPosition - 7) {
                        pos.x = calibrationDotsPosition[2].xPosition - 7;
                      }
                      if (pos.x < calibrationDotsPosition[0].xPosition + 7) {
                        pos.x = calibrationDotsPosition[0].xPosition + 7;
                      }
                    }
                    return pos;
                  }}
                />
              );
            })}
          </Layer>
        </Stage>
      </div>
    </div>
  );
};
